export default "__VITE_ASSET__64ce8a80__"